<template>
  <div v-if="loading" class="text-center" style="margin-top: 10em">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else>
    <transition appear name="slide-fade">
      <div>
        <div class="col-lg-12">
          <h3 class="text-orange">Información de pago</h3>
          <hr />
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-3">
              <!-- <router-link
                v-bind:to="'/beneficiarios/' + id_usuario"
                class="btn btn-orange rounded-pill"
              >
                <i class="bx bx-chevron-left"></i> Regresar
              </router-link> -->
              <button_back></button_back>
            </div>
            <div class="card">
              <div class="card-body">
                <div class="col-lg-12 form-group">
                  <label>Tipo de membresia <small>(Tipo de membresia que va a pagar, anual $198.000, semestral
                      $115.000)</small></label>
                  <select v-model="usuario.membresia.tipo_membresia" class="form-control">
                    <option value="1">Anual</option>
                    <option value="2">Semestral</option>
                  </select>
                </div>
                <div class="col-lg-12 form-group">
                  <label>Forma de pago <small>(Forma en la que realizara el pago)</small></label>
                  <select v-model="usuario.membresia.forma_pago" class="form-control">
                    <option value="1">Contado</option>
                    <option value="2">Dos cuotas</option>
                  </select>
                </div>
                <div class="col-lg-12 form-group">
                  <label>Medio de pago <small>(Medio por el que realizara el pago)</small></label>
                  <select v-model="usuario.membresia.medio_pago" class="form-control">
                    <option value="1">Efectivo</option>
                    <option value="2">Transferencia</option>
                  </select>
                </div>
                <div class="col-lg-12 form-group">
                  <label>Dirección de entrega <small>(Direccion donde se entregara la membresia)</small></label>
                  <input v-model="usuario.membresia.direccion_entrega" class="form-control" type="text" />
                </div>
                <div class="col-lg-12 text-end">
                  <button v-on:click="update_membresia(1)" class="btn btn-orange rounded-pill ms-1">
                    <i class="bx bx-save"></i> Guardar y finalizar
                  </button>
                  <button v-on:click="update_membresia(2)" class="btn btn-success rounded-pill ms-1">
                    <i class="bx bx-save"></i> Guardar y continuar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import axios from "axios";
import { defineAsyncComponent } from 'vue';
export default {
  name: "Pago",
  metaInfo: {
    title: "Pago - Reddy Backoffice",
  },
  components: {
    button_back: defineAsyncComponent(() => import('../../components/BackBtn')),
  },
  data() {
    return {
      loading: true,
      id_usuario: null,
      usuario: [],
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.id_usuario = this.$route.params.id_usuario;
    this.get_usuario();
  },
  methods: {
    get_usuario: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "clientes/cliente/" + this.id_usuario, config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.usuario = response.data.data;
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    update_membresia: function (step) {
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        membresia: this.usuario.membresia,
      };
      axios
        .post(this.$base_url + "membresias/update_membresia", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
            return false;
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Excelente",
              text: response.data.message,
            });
            switch (step) {
              case 1:
                vm.$router.push("/");
                break;
              case 2:
                vm.$router.push("/anexos_membresia/" + vm.id_usuario);
                break;
            }
          }
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
  },
  mounted: function () { },
};
</script>